import { createApiHandler } from './handler';

const inventories = {
  apiClient: null,
  path: '/franchises/inventories',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByBranch(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/branch/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createWithImage(form) {
    try {
      const response = await this.apiClient.post(`${this.path}`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default inventories;
